/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import '../../../activity.scss';
import { Grid } from 'semantic-ui-react';

import { CustomDropdown, CustomInput } from '../../../../../../components/form';
import countries from 'i18n-iso-countries';
import { useTranslation } from 'react-i18next';

export default function EmailResponseFormGuestUser({
  isView = false,
  disabled = false, // TODO: need to remove
  isActive = false,
  changeEmail = null,
  isShowEntityName = false, // TODO: need to remove
  projected = false,
  activity = null,
}) {
  const { t, i18n } = useTranslation();
  const renderCountries = () => {
    const currentLanguage = i18n.language || 'en';
    const countryObj = countries.getNames(currentLanguage, { select: 'alias' });

    return Object.entries(countryObj).map(([code, name]) => ({
      key: code,
      text: name,
      value: code,
    }));
  };

  return (
    <div>
      <Grid>
        <Grid.Column
          className="linked-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="firstName"
            name="firstName"
            placeholder={t('formulary.placeholder.enter_first_name')}
            labelText={t('formulary.first_name')}
            requiredStar
          />
        </Grid.Column>
        <Grid.Column
          className="linked-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="surname"
            name="surname"
            placeholder={t('formulary.placeholder.enter_last_name')}
            labelText={t('formulary.last_name')}
            requiredStar
          />
        </Grid.Column>
      </Grid>
      <Grid>
        {/* <Grid.Column
          className="linked-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="email"
            name="email"
            // getValue={e => changeEmail(e)}
            placeholder={t('common.enter_email')}
            labelText={t('common.email')}
            requiredStar
          />
        </Grid.Column> */}
        <Grid.Column
          className="linked-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="phone"
            name="phone"
            placeholder={t('formulary.placeholder.enter_phone')}
            labelText={t('formulary.phone')}
            requiredStar
          />
        </Grid.Column>
      </Grid>
      <>
        <Grid>
          <Grid.Column>
            <CustomInput
              id="entityName"
              name="entityName"
              placeholder={t(
                'formulary.placeholder.enter_business_organization_name'
              )}
              labelText={t('formulary.business_organization_name')}
              requiredStar
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <CustomDropdown
              search
              name="country"
              id="country"
              labelText={t('formulary.country')}
              placeholder={t('formulary.placeholder.select_country')}
              options={renderCountries()}
              requiredStar
            />
          </Grid.Column>
        </Grid>

        <Grid>
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <CustomInput
              id="address1"
              name="address1"
              placeholder={t('formulary.placeholder.enter_address_line_1')}
              labelText={t('formulary.address_line_1')}
              requiredStar
            />
          </Grid.Column>
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={8}
            computer={8}
          >
            <CustomInput
              id="address2"
              name="address2"
              placeholder={t('formulary.placeholder.enter_address_line_2')}
              labelText={t('formulary.address_line_2')}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={6}
            computer={6}
          >
            <CustomInput
              id="suburb"
              name="suburb"
              placeholder={t('formulary.placeholder.enter_suburb')}
              labelText={t('formulary.suburb')}
              requiredStar
            />
          </Grid.Column>
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={5}
            computer={5}
          >
            <CustomInput
              id="state"
              name="state"
              placeholder={t('formulary.placeholder.enter_state')}
              labelText={t('formulary.state')}
              requiredStar
            />
          </Grid.Column>
          <Grid.Column
            className="linked-activity-model-column"
            mobile={16}
            tablet={5}
            computer={5}
          >
            <CustomInput
              id="postcode"
              name="postcode"
              placeholder={t('formulary.placeholder.enter_postcode')}
              labelText={t('formulary.postcode')}
              requiredStar
            />
          </Grid.Column>
        </Grid>
      </>
    </div>
  );
}
